module.exports = __webpack_public_path__ + "e2af9da1d41a2970d5bed34a013e9007.svg";